import React, { Component } from 'react';
import AnnouncementsOverview from './../../Global/Modules/AnnouncementsOverview'

class Mededelingen extends Component {

  render() {
    return (
      <div className="route">
        <AnnouncementsOverview/>
      </div>
    );
  }  
}

export default Mededelingen;



// WEBPACK FOOTER //
// ./src/components/Public/Pages/Mededelingen.js